import { defaultMemoize, createSelectorCreator } from 'reselect';
import isEqual from 'lodash/isEqual';

export { createVersionedEntityHashDiffSelector } from './hash-diff';

export { createPropertyHashSelector } from './property-hash';
export type { PropertyHashSelector } from './property-hash';

export const createSelectorWithDefaultEqual = createSelectorCreator(defaultMemoize, isEqual);
